import { render, staticRenderFns } from "./ProjectAnalytics.vue?vue&type=template&id=19d77fa4"
import script from "./ProjectAnalytics.vue?vue&type=script&lang=js"
export * from "./ProjectAnalytics.vue?vue&type=script&lang=js"
import style0 from "./ProjectAnalytics.vue?vue&type=style&index=0&id=19d77fa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports